// extracted by mini-css-extract-plugin
export default {"content_wrap":"Team_content_wrap__6YoHW","user_image_wrap":"Team_user_image_wrap__ia0jl","department_cell":"Team_department_cell__c8HGs","role_cell":"Team_role_cell__UspdZ"};